import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Drawer from 'components/common/Drawer'
import AppointmentDetails from './AppointmentDetails'
import { composeFormattedPhoneNumberFromObject } from 'helpers/phone-number'

const Description = ({
  store: {
    address1,
    city,
    state,
    zipcode,
    phoneNumber = {},
    latitude,
    longitude
  } = {},
  orderId,
  updateCancelAppointment,
  emailModalData,
  isUpcomingAppointment,
  printHandler
}) =>
  <Wrapper>
    <Media.Desktop>
      <AppointmentDetails
        orderId={ orderId }
        address={{ address1, city, state, zipcode }}
        printHandler={ printHandler }
        emailModalData={ emailModalData }
        isUpcomingAppointment={ isUpcomingAppointment }
        phone={ composeFormattedPhoneNumberFromObject(phoneNumber) }
        updateCancelAppointment={ updateCancelAppointment }
        storeCoordinates={{ latitude, longitude, address1, city, zipcode }} />
    </Media.Desktop>
    <Media.Mobile>
      <DetailsDrawer title="Appointment Details" expandedByDefault>
        <AppointmentDetails
          orderId={ orderId }
          address={{ address1, city, state, zipcode }}
          printHandler={ printHandler }
          emailModalData={ emailModalData }
          isUpcomingAppointment={ isUpcomingAppointment }
          phone={ composeFormattedPhoneNumberFromObject(phoneNumber) }
          updateCancelAppointment={ updateCancelAppointment }
          storeCoordinates={{ latitude, longitude, address1, city, zipcode }} />
      </DetailsDrawer>
    </Media.Mobile>
  </Wrapper>

Description.propTypes = {
  emailModalData: PropTypes.shape(),
  isUpcomingAppointment: PropTypes.bool,
  orderId: PropTypes.string,
  printHandler: PropTypes.func,
  store: PropTypes.shape(),
  updateCancelAppointment: PropTypes.arrayOf(PropTypes.shape())
}

export default Description

const Wrapper = styled.div`
  border-bottom: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('padding', '24px 24px 40px', '0')}
  ${Mixin.clearFix()}
`

const DetailsDrawer = styled(Drawer)`
  border: none;
  ${Media.mobile`
    padding: 16px 20px;
  `}

  & [data-drawer-icon] {
    ${Media.mobile`
      top: 16px;
    `}
  }
`
